import { useEffect, useState } from 'react'
import { istOffline } from './api'
import { zeitKurz } from './datum'

/**
 * ⚠️ Regel 5: Offline heißt lesend. Gecachte GETs rendern mit sichtbarem „Stand von HH:MM".
 */
export function useOfflineStatus(): { offline: boolean; standVon: string } {
  const [offline, setOffline] = useState<boolean>(() => istOffline())
  const [standVon, setStandVon] = useState<string>(() => zeitKurz(new Date().toISOString()) ?? '')

  useEffect(() => {
    if (typeof window === 'undefined') return

    const beiOnline = () => {
      setOffline(false)
    }
    const beiOffline = () => {
      setStandVon(zeitKurz(new Date().toISOString()) ?? '')
      setOffline(true)
    }

    window.addEventListener('online', beiOnline)
    window.addEventListener('offline', beiOffline)

    return () => {
      window.removeEventListener('online', beiOnline)
      window.removeEventListener('offline', beiOffline)
    }
  }, [])

  return { offline, standVon }
}
